module.exports = __webpack_public_path__ + "static/media/edit.2fcb9dc7.svg";